import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data: data
  })
}

export function getInfo(data) {
  return request({
    url: '/auth/validatetoken',
    method: 'post',
    data: data
  })
}
//POST /auth/tokenLogin token登录
export function tokenLogin(data) {
  return request({
    url: '/auth/validatetoken',
    method: 'post',
    data: data
  })
}
//POST /auth/refreshToken 刷新token
export function refToken(data) {
  return request({
    url: '/auth/refreshtoken',
    method: 'post',
    data: data
  })
}

//POST /auth/logout 退出登录(清除记住我redis缓存)
export function logout(data) {
  return request({
    url: '/auth/logout',
    method: 'post',
    data: data
  })
}

//POST /auth/autoLogin 自动登录(记住我token登录)
export function autoLogin(data) {
  return request({
    url: '/auth/autoLogin',
    method: 'post',
    data: data
  })
}







// WEBPACK FOOTER //
// ./src/api/login.js